// extracted by mini-css-extract-plugin
export default {"container":"CryptoChart_container__aTLWb","tvcontainer":"CryptoChart_tvcontainer__BEV4q"};